import { NAME } from './constants';
import { router } from './router';

export const WmsAdmin = {
	name: NAME,
	router,
};
